import res from '@/assets/data/countries.json';
import { FormDropdownOption } from '@/types/form/form-dropdown/form-dropdown';
export const getCountries = async () => {
  return res.data.countries;
};
export const getCountryOptions = async (textKey = 'name', valueKey = 'country_code') => {
  const data = await getCountries();
  return data.map((country) => ({
    text: country[textKey as keyof typeof country],
    value: country[valueKey as keyof typeof country],
  })) as FormDropdownOption[];
};
